<template>
  <div class="salary-detail">
    <div class="nav">
      <img
        src="https://portal-minio.pass.lygtc.edu.cn/cms/%E9%A1%B6%E9%83%A8%E5%AF%BC%E8%88%AA%E6%A0%8Flogo-1607933659282.png"
        alt=""
      />
      <span class="ml">|</span>
      <span>工资查询信息</span>
    </div>
    <div class="salary-content">
      <div class="title">工资查询信息</div>
      <div class="book-form">
        <el-card class="box-card">
          <el-form ref="form" :model="form" label-width="80px" :inline="true">
            <el-form-item label="选择日期：">
              <el-date-picker
                v-model="form.monthValue"
                type="month"
                placeholder="选择月份"
                value-format="yyyy-MM"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearchSalary">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
          </el-form>
          <div class="el-table-style">
            <div class="el-table-user">
              <el-table
                :data="salaryData"
                border
                style="width: 100%"
                height="calc(100vh - 320px)"
              >
                <el-table-column
                  fixed
                  prop="ny"
                  label="年月"
                  width="80"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="zhj" label="合计" align="center">
                </el-table-column>
                <el-table-column prop="gwgz" label="岗位工资" align="center">
                </el-table-column>
                <el-table-column prop="xjgz" label="薪级工资" align="center">
                </el-table-column>
                <el-table-column prop="gwjt" label="岗位津贴" align="center">
                </el-table-column>
                <el-table-column prop="jlxjx" label="奖励性绩效" align="center">
                </el-table-column>
                <el-table-column prop="shbt" label="生活补贴" align="center">
                </el-table-column>
                <el-table-column prop="qbjf" label="缺编经费" align="center">
                </el-table-column>
                <el-table-column prop="jbt" label="津补贴" align="center">
                </el-table-column>
                <el-table-column prop="ft" label="房贴" align="center">
                </el-table-column>
                <el-table-column prop="ct" label="车贴" align="center">
                </el-table-column>
                <el-table-column prop="bf" label="补发" align="center">
                </el-table-column>
                <el-table-column prop="lsxbt" label="临时性补贴" align="center">
                </el-table-column>
                <el-table-column prop="kkhj" label="扣款合计" align="center">
                </el-table-column>
                <el-table-column prop="gjj" label="公积金" align="center">
                </el-table-column>
                <el-table-column prop="ylbx" label="医疗保险" align="center">
                </el-table-column>
                <el-table-column
                  prop="ylbx2"
                  label="养老保险（预交款）"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="sybx" label="失业保险" align="center">
                </el-table-column>
                <el-table-column prop="hf" label="会费" align="center">
                </el-table-column>
                <el-table-column prop="kf" label="扣发" align="center">
                </el-table-column>
                <el-table-column prop="ks" label="扣税" align="center">
                </el-table-column>
                <el-table-column prop="sf" label="实发" align="center">
                </el-table-column>
                <el-table-column
                  prop="jsyhkh"
                  label="江苏银行卡"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="ksjs" label="扣税基数" align="center">
                </el-table-column>
                <el-table-column prop="sfzh" label="身份证号" align="center">
                </el-table-column>
                <el-table-column prop="bz" label="备注" align="center">
                </el-table-column>
                <el-table-column prop="dfyhkh" label="东方银行" align="center">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="totalSize"
          >
          </el-pagination>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getSalaryList, getDateSalaryList } from '@/api/lianyungang.js';
export default {
  data() {
    return {
      form: {
        monthValue: '',
      },
      salaryData: [],
      // 当前页
      currentPage: 1,
      // 一页显示多少条
      pageSize: 10,
      // 总页数
      totalSize: 100,
      // 地址参数
      userName: '',
    };
  },
  mounted() {
    this.fetchUrlInfo();
    this.fetchSalaryList();
  },
  methods: {
    // 获取地址栏上的参数
    fetchUrlInfo() {
      let urlInfo = window.location.href;
      this.userName = urlInfo.split('?')[1];
    },
    // 根据日期判断数据
    onSearchSalary() {
      let data = {
        schoolYear: this.form.monthValue,
        userName: this.userName,
      };
      getDateSalaryList(data).then((res) => {
        this.salaryData = res.data.data.list;
        this.form.monthValue = '';
        this.totalSize = this.salaryData.length;
      });
    },
    // 获取薪资数据
    fetchSalaryList() {
      let data = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        userName: this.userName,
      };
      getSalaryList(data).then((res) => {
        if (res.code == 0) {
          this.salaryData = res.data.data.list;
          this.totalSize = res.data.data.total;
        }
      });
    },
    onReset() {
      this.fetchSalaryList();
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchSalaryList();
    },
  },
};
</script>

<style lang="scss" scoped>
.salary-detail {
  .nav {
    display: flex;
    align-items: center;
    padding: 0 60px;
    height: 60px;
    width: 100%;
    height: 60px;
    background: rgb(57, 131, 218);
    color: #fff;
    .ml {
      margin-left: 4px;
      margin-right: 4px;
    }
    img {
      margin-top: 4px;
      vertical-align: middle;
    }
  }
  .salary-content {
    margin: 0 60px;
    .title {
      margin: 20px 0;
      color: rgb(57, 131, 218);
    }
    /deep/.el-form {
      display: flex;
      justify-content: flex-end;
    }
  }
  /deep/.el-form-item__label {
    width: 100px !important;
    font-size: 16px;
  }
  /deep/.el-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  /deep/.el-table .cell {
    white-space: pre-line !important;
  }
  .el-table-style {
    width: 100%;
    // height: calc(100vh - 320px);
  }
  .el-table-user {
    max-height: 100%;
    overflow-y: auto;
  }
}
</style>